/* eslint-disable import/prefer-default-export */
export const getCountryWiseData = (list: Array<any>) => {
  const countryWiseData = list?.reduce((acc, curr) => {
    const country = curr?.location_country_long_name;
    if (!acc[country]) {
      acc[country] = [];
    }
    acc[country].push(curr);
    return acc;
  }, {});

  return countryWiseData || {};
};
